module.exports = __webpack_public_path__ + "static/media/promo_MVW_AboundLogo_desktop.86306308.png";